export default (Vue) => {
  Vue.mixin({
    data(){
      return{
        mixin_datas: [],
        mixin_params:{
          searchText:'',
          currentIndex:0
        }
      }
    },
    computed:{
      user(){
        return this.$store.getters.userInfo
      }
    },
    methods:{
      _scroller_refresh(done){
        this.mixin_params.currentIndex = 1
        this.mixin_datas=[]
        // setTimeout(() => {
          this._loadData().then(res=>{
            done()
            if(this.$refs.myscroller){
              this.$refs.myscroller.finishPullToRefresh()
            }
            if(!res && this.$refs.myscroller){
              this.$refs.myscroller.finishInfinite(true)
            }
          })
        // }, 300)
      },
      _scroller_infinite(done) {
        // setTimeout(() => {
          this.mixin_params.currentIndex++
          this._loadData().then(res=>{
            done()
            if(this.$refs.myscroller){
              this.$refs.myscroller.finishPullToRefresh()
            }
            if(!res && this.$refs.myscroller){
              this.$refs.myscroller.finishInfinite(true)
            }
          })
        // }, 300)
      },
      _search_submit(){
        this.$refs.myscroller.triggerPullToRefresh()
        // this.mixin_params.currentIndex = 0
        // this.mixin_datas=[]
        // this.$refs.myscroller.finishInfinite(false)
      },
      _search_cancel(){
        this.mixin_params.searchText = ''
        this.$refs.myscroller.triggerPullToRefresh()
      },
      _loadData(){
        this.$loading()//'数据加载中...'
        return new Promise((resolve, reject) => {
          this.getList(this.mixin_params).then(res=>{
            this.$vux.loading.hide()
            if(res.result){
              if(res.data.length == 0){
                resolve(false)
              }else{
                res.data.filter(a=>{
                  this.mixin_datas.push(a)
                })
                resolve(true)
              }
            }else{
              resolve(false)
            }
          })
        })
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/assets/js/utils/mixin.js